import { type LoaderFunction } from '@remix-run/node'
import parse from 'html-react-parser'
import { redirect } from '@remix-run/node'
import { type Author } from '~/gql/queries.ts'
import { getPage } from '~/utils/graphql.ts'
import { useLoaderData } from '@remix-run/react'

type LoaderType = {
	title: string
	content: string
	date: string
	author: Author
}
export let loader: LoaderFunction = async (): Promise<
	LoaderType | undefined
> => {
	try {
		const page = await getPage('about')
		return page
	} catch (error) {
		throw redirect('/')
	}
}

export default function AboutRoute() {
	const { content, title } = useLoaderData<LoaderType>()
	const body = parse.domToReact(parse.htmlToDOM(content))

	return (
		<>
			<h1 className="pb-4 text-center font-serif text-2xl uppercase tracking-widest">
				{title}
			</h1>
			<article className="post font-header flex flex-col space-y-3 pb-4 text-sm font-normal leading-7 tracking-wider text-gray-900">
				{body}
			</article>
		</>
	)
}
